import React from 'react';
import { Heart } from 'lucide-react';

const Header = ({ title, subtitle, rightAction }) => {
  return (
    <div className="bg-white border-b border-stone-100 px-4 py-4 flex justify-between items-center sticky top-0 z-40 shadow-sm">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-brand-500 rounded-full flex items-center justify-center shadow">
          <Heart className="w-5 h-5 text-white" fill="white" />
        </div>
        <div>
          <h1 className="font-bold text-lg text-stone-800 leading-tight font-display">{title}</h1>
          {subtitle && <p className="text-xs text-stone-500">{subtitle}</p>}
        </div>
      </div>
      {rightAction && <div>{rightAction}</div>}
    </div>
  );
};

export default Header;
